export default {
  'user-groups.title': 'Manage User Groups',
  'user-groups.action.users': 'Users',
  'users-groups.title': 'Manage User Groups',
  'users-groups.userExists': 'The user already belongs to this group',
  'users-groups.form.selectUser': 'Select a User',
};
